import { IFeature } from '@ms/odsp-utilities/lib/features/Features';
import { spFeatureConfigurationFacet } from '../../dataSource/Facets';
import { isSPFeatureEnabled } from '@ms/odsp-utilities/lib/features/FeaturesBasic';
import { IItemCache } from '@ms/items-view/lib/private/models/IItemCacheObserver';
import { getConfiguration } from '@ms/items-view/lib/private/models/configuration/getConfiguration';

/**
 * @internal
 */
export function getFeatureChecker(itemCache: IItemCache): (feature: IFeature, features: number[]) => boolean {
  const {
    featureConfiguration
  } = getConfiguration(itemCache, {
    featureConfiguration: spFeatureConfigurationFacet
  });

  return featureConfiguration && featureConfiguration.isFeatureEnabled || isSPFeatureEnabled;
}
